import React, { Fragment, useMemo } from "react";
import { ReactSVG } from "react-svg";
import { motion } from "framer-motion";
import { useDispatch, useSelector } from "react-redux";
import {
  patchGameSpokenLanguage,
  spokenLanguageGameCompleted,
} from "../../actions/game.action";
import { toast } from "react-toastify";

import { useTranslation } from "react-i18next";
import {
  checkSubArrayIncludes,
  getAreaModeBySpokenLanguage,
} from "../../utils";
import FlagCard from "../gadgets/FlagCard";

const SpokenLanguagesPage = () => {
  const { t } = useTranslation();

  const dispatch = useDispatch();

  const { spokenLanguage, countryOfToday } = useSelector(({ game }) => game);

  const handleGuess = (newGuess) => {
    if (
      checkSubArrayIncludes(
        [...spokenLanguage.guesses, newGuess],
        countryOfToday.languages,
      )
    ) {
      toast.success(t("Congratulations!"));
      dispatch(spokenLanguageGameCompleted());
    }
    if (spokenLanguage.guesses.length < 8) {
      dispatch(
        patchGameSpokenLanguage({
          guesses: [...new Set([...spokenLanguage.guesses, newGuess])],
        }),
      );
    }
  };

  const choicesMap = useMemo(
    () =>
      countryOfToday.languages_choices?.map((item, idx) => ({
        ...item,
        label: "ABCDEFGHIJKLMNOP"[idx],
        mode: getAreaModeBySpokenLanguage(
          item.language,
          spokenLanguage?.guesses,
          countryOfToday?.languages,
          spokenLanguage.completed,
        ),
      })),
    [countryOfToday, spokenLanguage],
  );

  return (
    <Fragment>
      <div
        className={`relative mt-6 flex w-full flex-row items-center justify-start text-center font-bold text-slate-800 dark:text-slate-100 `}
      >
        <ReactSVG className="mr-2 w-24" src="/images/language.svg" />
        {t("Do you know the spoken languages in", {
          country: countryOfToday?.name,
        })}
      </div>
      <div className={`my-4 grid w-full grid-cols-3 items-center gap-2`}>
        {choicesMap?.map((item, idx) => (
          <motion.div
            key={`svg-button-${idx}`}
            initial={{ opacity: 0, translateX: 20, translateY: -20 }}
            animate={{ opacity: 1, translateX: 0, translateY: 0 }}
            transition={{ delay: idx * 0.1 }}
          >
            <FlagCard
              item={item}
              idx={idx}
              completed={spokenLanguage.completed}
              handleGuess={handleGuess}
            />
          </motion.div>
        ))}
      </div>
    </Fragment>
  );
};

export default SpokenLanguagesPage;
